// import { useState } from "react";
// import {
//     FaMapMarkerAlt,
//     FaWifi,
//     FaTv,
//     FaExpand,
//     FaWhatsapp,
//     FaPhone,
//     FaBath,
//     FaInfoCircle,
//     FaHotTub,
//     FaCalendarAlt,
//     FaClock,
//     FaLock,
//     FaBuilding,
//     FaVenusMars,
// } from "react-icons/fa";
// import {
//     MdBalcony,
//     MdClose,
//     MdKeyboardArrowLeft,
//     MdKeyboardArrowRight,
// } from "react-icons/md";
// import { TbAirConditioning } from "react-icons/tb";
// import { GiCooler, GiWashingMachine } from "react-icons/gi";
// import Images from "../../Images";
// import tw from "tailwind-styled-components";

// // ==================== CONFIGURATION DATA (Easily replaceable by API) ====================
// const propertyData = {
//     // Basic Info
//     id: "1487718196644163530",
//     title: "Luxury Suite In Highrise With 290 Degree View",
//     location: "Gurugram, Haryana, India",
//     coordinates: {
//         lat: 28.4595,
//         lng: 77.0266,
//     },
//     // Host Info
//     host: {
//         name: "Sumit",
//         isSuperhost: true,
//         yearsHosting: 2,
//         responseRate: 100,
//         responseTime: "within an hour",
//         avatar: null,
//         ownerMobile: "+91 1234567890"
//     },

//     // Property Details
//     type: "Entire rental unit",
//     capacity: {
//         guests: 4,
//         bedrooms: 2,
//         beds: 2,
//         bathrooms: 1,
//     },

//     // Rental Terms
//     agreementPeriod: "12 months",
//     noticePeriod: "2 months",
//     lockinPeriod: "6 months",
//     propertyType: "Luxury Apartment",
//     tenantPreference: "Male",

//     // Images
//     images: [
//         "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1000",
//         "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1000",
//         "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1000",
//         "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1000",
//         "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1000",
//         "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1000",
//         "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000",
//         "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1000",
//         "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=1000",
//         "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=1000",
//         "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1000",
//     ],

//     // Amenities
//     amenities: [
//         { icon: FaWifi, name: "Wifi" },
//         { icon: TbAirConditioning, name: "Air Conditioning" },
//         { icon: FaBath, name: "Attached Bathroom" },
//         { icon: FaTv, name: "TV" },
//         { icon: MdBalcony, name: "Balcony" },
//         { icon: GiCooler, name: "Cooler" },
//         { icon: FaHotTub, name: "Geyser" },
//         { icon: GiWashingMachine, name: "Washing Machine" },
//     ],

//     // Sharing Options
//     sharingOptions: [
//         {
//             type: "Single Sharing",
//             price: 25000,
//             security: 50000,
//             rooms: 3,
//             features: ["High-Speed WiFi (1 Gbps)", "Cooler / Air Cooler"],
//         },
//         {
//             type: "Double Sharing",
//             price: 15000,
//             security: 30000,
//             rooms: 5,
//             features: ["High-Speed WiFi (1 Gbps)", "Washing Machine & Dryer"],
//         },
//         {
//             type: "Triple Sharing",
//             price: 11000,
//             security: 25000,
//             rooms: 2,
//             features: ["Air Conditioning (Central AC)", "Smart TV with Streaming"],
//         },
//     ],
// };

// const PropertyShareLink = () => {
//     const [showAllPhotos, setShowAllPhotos] = useState(false);
//     const [selectedSharing, setSelectedSharing] = useState(0);
//     const [fullScreenImageIndex, setFullScreenImageIndex] = useState(0);

//     const handleFullScreenNavigation = (direction) => {
//         if (direction === "prev") {
//             setFullScreenImageIndex((prev) =>
//                 prev === 0 ? propertyData.images.length - 1 : prev - 1,
//             );
//         } else {
//             setFullScreenImageIndex((prev) =>
//                 prev === propertyData.images.length - 1 ? 0 : prev + 1,
//             );
//         }
//     };

//     // Full Screen Modal Component
//     const FullScreenModal = () => (
//         <ModalOverlay>
//             <CloseButton onClick={() => setShowAllPhotos(false)}>
//                 <MdClose size={20} />
//             </CloseButton>

//             <ModalContent onClick={(e) => e.stopPropagation()}>
//                 <ImageContainer>
//                     <FullScreenImage
//                         src={propertyData.images[fullScreenImageIndex]}
//                         alt={`Property ${fullScreenImageIndex + 1}`}
//                         onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src =
//                                 "https://via.placeholder.com/800x600?text=Image+Not+Available";
//                         }}
//                     />

//                     <NavButton
//                         className="left-2 sm:left-4"
//                         onClick={() => handleFullScreenNavigation("prev")}
//                     >
//                         <MdKeyboardArrowLeft size={24} />
//                     </NavButton>

//                     <NavButton
//                         className="right-2 sm:right-4"
//                         onClick={() => handleFullScreenNavigation("next")}
//                     >
//                         <MdKeyboardArrowRight size={24} />
//                     </NavButton>

//                     <ImageCounter>
//                         Image {fullScreenImageIndex + 1} of {propertyData.images.length}
//                     </ImageCounter>
//                 </ImageContainer>

//                 <ThumbnailStrip>
//                     {propertyData.images.map((img, idx) => (
//                         <ThumbnailButton
//                             key={idx}
//                             onClick={() => setFullScreenImageIndex(idx)}
//                             className={
//                                 idx === fullScreenImageIndex
//                                     ? "border-blue-500 ring-2 ring-blue-200"
//                                     : "border-gray-600 hover:border-gray-400"
//                             }
//                         >
//                             <img
//                                 src={img}
//                                 alt={`Thumbnail ${idx + 1}`}
//                                 className="w-full h-full object-cover"
//                                 onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src =
//                                         "https://via.placeholder.com/100x100?text=Error";
//                                 }}
//                             />
//                         </ThumbnailButton>
//                     ))}
//                 </ThumbnailStrip>
//             </ModalContent>
//         </ModalOverlay>
//     );
//     const AirbnbMapSection = ({ data }) => {
//         const { coordinates, title, location } = data;

//         if (!coordinates) return null;

//         const mapUrl = `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}&z=15&output=embed`;

//         return (
//             <section className="border-t mt-12 py-5 sm:py-7">
//                 {/* Title */}
//                 <SectionTitle>
//                     Where you'll be
//                 </SectionTitle>

//                 {/* Map Container */}
//                 <div className="relative h-[320px] sm:h-[420px] rounded-2xl overflow-hidden shadow-xl group">

//                     {/* MAP (iframe) */}
//                     <iframe
//                         src={mapUrl}
//                         className="w-full h-full"
//                         loading="lazy"
//                         referrerPolicy="no-referrer-when-downgrade"
//                         title="Map location display"
//                     ></iframe>

//                     {/* DARK OVERLAY */}
//                     {/* <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition duration-500"></div> */}

//                     {/* GLASS CARD */}
//                     <div className="absolute bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:w-[320px] 
//                     backdrop-blur-xl bg-white/80 border border-white/40 
//                     rounded-xl shadow-lg p-4 transition-all duration-300 group-hover:scale-[1.02]">

//                         <div className="flex items-start gap-3">
//                             <div className="bg-primary-color/10 text-primary-color p-2 rounded-lg">
//                                 📍
//                             </div>

//                             <div>
//                                 <h4 className="font-semibold text-sm sm:text-base text-gray-800 line-clamp-1">
//                                     {title}
//                                 </h4>

//                                 <p className="text-xs sm:text-sm text-gray-600 mt-1">
//                                     {location}
//                                 </p>

//                                 {/* BUTTONS */}
//                                 <div className="flex gap-2 mt-3">
//                                     <a
//                                         href={`https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`}
//                                         target="_blank"
//                                         rel="noreferrer"
//                                         className="text-xs px-3 py-1.5 bg-primary-color text-white rounded-lg font-medium hover:opacity-90 transition"
//                                     >
//                                         View on Maps
//                                     </a>

//                                     <a
//                                         href={`https://www.google.com/maps/dir/?api=1&destination=${coordinates.lat},${coordinates.lng}`}
//                                         target="_blank"
//                                         rel="noreferrer"
//                                         className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition"
//                                     >
//                                         Get Directions
//                                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* TOP BADGE */}
//                     <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded-lg text-xs font-semibold shadow">
//                         📍 Prime Location
//                     </div>
//                 </div>
//             </section>
//         );
//     };
//     return (
//         <Container>
//             {/* Header */}
//             {/* <Header>
//                 <HeaderContainer>
//                     <Logo src={Images.Logo} alt="Kipinn Logo" />
//                 </HeaderContainer>
//             </Header> */}
//             <Header>
//                 <HeaderContainer>

//                     {/* Left - Logo */}
//                     <Logo src={Images.Logo} alt="Kipinn Logo" />

//                     {/* Right - Actions */}
//                     <HeaderActions>

//                         <WhatsAppHeaderBtn
//                             onClick={() => {
//                                 const phone = propertyData?.host?.ownerMobile;
//                                 if (!phone) return;

//                                 window.open(`https://wa.me/${phone}`, "_blank");
//                             }}
//                         >
//                             <FaWhatsapp className="w-4 h-4" />
//                             <span className="hidden sm:inline">WhatsApp</span>
//                         </WhatsAppHeaderBtn>

//                         <CallHeaderBtn
//                             onClick={() => {
//                                 const phone = propertyData?.host?.ownerMobile;
//                                 if (!phone) return;

//                                 window.location.href = `tel:${phone}`;
//                             }}
//                         >
//                             <FaPhone className="w-4 h-4" />
//                             <span className="hidden sm:inline">Call</span>
//                         </CallHeaderBtn>

//                     </HeaderActions>

//                 </HeaderContainer>
//             </Header>
//             <Main>
//                 {/* Title Section */}
//                 <div className="mb-4 sm:mb-6">
//                     <Title>{propertyData.title}</Title>
//                     <div className="flex flex-wrap items-center gap-2 mt-2 text-xs sm:text-sm text-gray-700">
//                         <div className="flex items-center gap-1">
//                             <FaMapMarkerAlt className="w-3 h-3 sm:w-4 sm:h-4" />
//                             <LocationText>{propertyData.location}</LocationText>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Photo Gallery */}
//                 <GalleryGrid>
//                     <MainImageContainer>
//                         <GalleryImage
//                             src={propertyData.images[0]}
//                             alt="Main"
//                             onClick={() => {
//                                 setFullScreenImageIndex(0);
//                                 setShowAllPhotos(true);
//                             }}
//                             onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                     "https://via.placeholder.com/800x600?text=Image+Not+Available";
//                             }}
//                         />
//                     </MainImageContainer>
//                     {propertyData.images.slice(1, 5).map((img, idx) => (
//                         <div key={idx} className="relative">
//                             <GalleryImage
//                                 src={img}
//                                 alt={`Gallery ${idx + 2}`}
//                                 onClick={() => {
//                                     setFullScreenImageIndex(idx + 1);
//                                     setShowAllPhotos(true);
//                                 }}
//                                 onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src =
//                                         "https://via.placeholder.com/400x300?text=Image+Not+Available";
//                                 }}
//                             />
//                             {idx === 3 && (
//                                 <ShowAllPhotosButton
//                                     onClick={() => {
//                                         setFullScreenImageIndex(0);
//                                         setShowAllPhotos(true);
//                                     }}
//                                 >
//                                     <FaExpand className="w-3 h-3 sm:w-4 sm:h-4" />
//                                     Show all photos
//                                 </ShowAllPhotosButton>
//                             )}
//                         </div>
//                     ))}
//                 </GalleryGrid>

//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
//                     {/* Left Column - Details */}
//                     <div className="lg:col-span-2">
//                         {/* Host Info */}
//                         <HostSection>
//                             <HostInfo>
//                                 <div>
//                                     <HostName>
//                                         {propertyData.type} managed by{" "}
//                                         <span className="text-primary-color">
//                                             {propertyData.host.name}
//                                         </span>
//                                     </HostName>
//                                     {propertyData.host.isSuperhost && (
//                                         <div className="flex items-center gap-1 mt-1">
//                                             {/* <FaStar className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-500 fill-current" /> */}
//                                             <span className="text-xs sm:text-sm text-gray-600">
//                                                 Owner
//                                             </span>
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* <ButtonGroup>
//                                     <WhatsAppButton
//                                         onClick={() => {
//                                             const phone = propertyData?.host?.ownerMobile;
//                                             if (!phone) return;

//                                             window.open(`https://wa.me/${phone}`, "_blank");
//                                         }}
//                                     >
//                                         <FaWhatsapp className="w-4 h-4 sm:w-5 sm:h-5" />
//                                         <span>WhatsApp</span>
//                                     </WhatsAppButton>

//                                     <CallButton
//                                         onClick={() => {
//                                             const phone = propertyData?.host?.ownerMobile;
//                                             if (!phone) return;

//                                             window.location.href = `tel:${phone}`;
//                                         }}
//                                     >
//                                         <FaPhone className="w-4 h-4 sm:w-5 sm:h-5" />
//                                         <span>Call Now</span>
//                                     </CallButton>
//                                 </ButtonGroup>

//                                 <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-500">
//                                     <div className="flex items-center gap-1">
//                                         <FaInfoCircle className="w-3 h-3 sm:w-4 sm:h-4" />
//                                         <span>
//                                             Response rate: {propertyData.host.responseRate}%
//                                         </span>
//                                     </div>
//                                     <div className="w-1 h-1 bg-gray-300 rounded-full hidden sm:block"></div>
//                                     <div className="flex items-center gap-1">
//                                         <FaClock className="w-3 h-3 sm:w-4 sm:h-4" />
//                                         <span>Responds {propertyData.host.responseTime}</span>
//                                     </div>
//                                 </div> */}
//                             </HostInfo>
//                         </HostSection>

//                         {/* Rental Terms Section */}

//                         <Section className="border-b">
//                             <SectionTitle>Rental Terms</SectionTitle>

//                             <TermsGrid>
//                                 {[
//                                     {
//                                         icon: FaCalendarAlt,
//                                         label: "Agreement Period",
//                                         value: propertyData.agreementPeriod,
//                                     },
//                                     {
//                                         icon: FaClock,
//                                         label: "Notice Period",
//                                         value: propertyData.noticePeriod,
//                                     },
//                                     {
//                                         icon: FaLock,
//                                         label: "Lock-in Period",
//                                         value: propertyData.lockinPeriod,
//                                     },
//                                     {
//                                         icon: FaBuilding,
//                                         label: "Property Type",
//                                         value: propertyData.propertyType,
//                                     },
//                                     {
//                                         icon: FaVenusMars,
//                                         label: "Tenant Preference",
//                                         value: propertyData.tenantPreference,
//                                     },
//                                 ].map((item, idx) => {
//                                     const Icon = item.icon;
//                                     return (
//                                         <TermCard key={idx}>
//                                             <IconWrapper>
//                                                 <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
//                                             </IconWrapper>

//                                             <div>
//                                                 <p className="text-xs sm:text-sm text-gray-500">
//                                                     {item.label}
//                                                 </p>
//                                                 <p className="text-sm sm:text-base font-semibold text-gray-800">
//                                                     {item.value}
//                                                 </p>
//                                             </div>
//                                         </TermCard>
//                                     );
//                                 })}
//                             </TermsGrid>
//                         </Section>
//                         {/* Amenities */}
//                         <Section>
//                             <SectionTitle>What this place offers</SectionTitle>
//                             <AmenitiesGrid>
//                                 {propertyData.amenities.map((item, idx) => (
//                                     <div key={idx} className="flex items-center gap-2 sm:gap-3">
//                                         <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
//                                         <span className="text-sm sm:text-base text-gray-700">
//                                             {item.name}
//                                         </span>
//                                     </div>
//                                 ))}
//                             </AmenitiesGrid>
//                         </Section>
//                     </div>

//                     {/* Right Column - Booking Card */}
//                     <div className="lg:col-span-1">
//                         <BookingCard>
//                             <SectionTitle className="text-lg sm:text-xl">
//                                 Choose Sharing
//                             </SectionTitle>
//                             <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-5">
//                                 {propertyData.sharingOptions.map((item, index) => (
//                                     <SharingOption
//                                         key={index}
//                                         onClick={() => setSelectedSharing(index)}
//                                         className={
//                                             selectedSharing === index
//                                                 ? "border-primary-color bg-primary-color/10 shadow-md"
//                                                 : "hover:shadow-sm"
//                                         }
//                                     >
//                                         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
//                                             <h4 className="text-sm sm:text-base font-semibold">
//                                                 {item.type}
//                                             </h4>
//                                             <span className="text-base sm:text-lg font-bold text-primary-color">
//                                                 ₹{item.price.toLocaleString()}
//                                                 <span className="text-xs text-gray-500"> /month</span>
//                                             </span>
//                                         </div>

//                                         <p className="text-xs text-gray-500 mt-1">
//                                             Security: ₹{item.security.toLocaleString()}
//                                         </p>

//                                         <p className="text-xs text-green-600 mt-2">
//                                             🏠 {item.rooms} rooms available
//                                         </p>
//                                     </SharingOption>
//                                 ))}
//                             </div>

//                             <CallButton
//                                 onClick={() => {
//                                     const phone = propertyData?.host?.ownerMobile;
//                                     if (!phone) return;

//                                     window.location.href = `tel:${phone}`;
//                                 }}
//                                 className="w-full py-2.5 sm:py-3 mb-3 sm:mb-4 flex items-center justify-center gap-2"
//                             >
//                                 <FaPhone className="w-4 h-4 sm:w-5 sm:h-5" />
//                                 <span>Call Now</span>
//                             </CallButton>
//                             <div className="space-y-2 text-xs sm:text-sm">
//                                 <div className="flex justify-between">
//                                     <span>Monthly Rent</span>
//                                     <span>
//                                         ₹
//                                         {propertyData.sharingOptions[
//                                             selectedSharing
//                                         ].price.toLocaleString()}
//                                     </span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                     <span>Security Deposit</span>
//                                     <span>
//                                         ₹
//                                         {propertyData.sharingOptions[
//                                             selectedSharing
//                                         ].security.toLocaleString()}
//                                     </span>
//                                 </div>
//                                 <div className="border-t pt-2 sm:pt-3 mt-2 sm:mt-3 font-semibold flex justify-between">
//                                     <span>Total Move-in Cost</span>
//                                     <span>
//                                         ₹
//                                         {(
//                                             propertyData.sharingOptions[selectedSharing].price +
//                                             propertyData.sharingOptions[selectedSharing].security
//                                         ).toLocaleString()}
//                                     </span>
//                                 </div>
//                             </div>
//                         </BookingCard>
//                     </div>
//                 </div>
//                 <AirbnbMapSection data={propertyData} />
//             </Main>

//             {showAllPhotos && <FullScreenModal />}
//         </Container>
//     );
// };


// // ==================== STYLED COMPONENTS ====================

// const Container = tw.div`min-h-screen bg-white`;
// const Header = tw.header`border-b sticky top-0 bg-white z-40 shadow-sm`;
// const HeaderContainer = tw.div`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between`;
// const Logo = tw.img`w-16 sm:w-20`;
// const HeaderActions = tw.div`
//   flex items-center gap-2 sm:gap-3
// `;

// const WhatsAppHeaderBtn = tw.button`
//   flex items-center gap-1 sm:gap-2
//   bg-green-500 hover:bg-green-400
//   text-white px-3 sm:px-4 py-2
//   rounded-lg font-medium text-xs sm:text-sm
//   transition-all duration-300 shadow-sm
// `;

// const CallHeaderBtn = tw.button`
//   flex items-center gap-1 sm:gap-2
//   bg-primary-color hover:bg-hover-color
//   text-white px-3 sm:px-4 py-2
//   rounded-lg font-medium text-xs sm:text-sm
//   transition-all duration-300 shadow-sm
// `;
// const Main = tw.main`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6`;
// const Title = tw.h1`text-xl sm:text-2xl md:text-3xl font-semibold leading-tight`;
// const LocationText = tw.span`text-sm`;
// const GalleryGrid = tw.div`grid grid-cols-2 sm:grid-cols-4 gap-1 sm:h-80 md:h-96 rounded-xl overflow-hidden mb-6 sm:mb-8`;
// const MainImageContainer = tw.div`col-span-2 row-span-2`;
// const GalleryImage = tw.img`w-full h-full object-cover cursor-pointer hover:opacity-95 transition-opacity`;
// const ShowAllPhotosButton = tw.button`absolute bottom-3 lg:bottom-8 right-3 bg-white rounded-lg px-3 py-1.5 text-xs font-semibold flex items-center gap-2 shadow-md hover:bg-gray-100 transition-colors z-10`;
// // Host Info Components
// const HostSection = tw.div`flex flex-col sm:flex-row justify-between items-start border-b pb-4 sm:pb-6 `;
// const HostInfo = tw.div`space-y-3 sm:space-y-4 w-full sm:w-auto`;
// const HostName = tw.h2`text-xl sm:text-2xl font-semibold text-gray-900`;
// const ButtonGroup = tw.div`flex flex-row gap-2 sm:gap-3`;
// const WhatsAppButton = tw.button`group relative px-4 sm:px-5 py-2 sm:py-2.5 bg-green-500 hover:bg-green-600 text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`;
// const CallButton = tw.button`group relative px-4 sm:px-5 py-2 sm:py-2.5 bg-primary-color hover:bg-hover-color text-white rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base`;
// // Section Components
// const Section = tw.section`py-5 sm:py-7`;
// const SectionTitle = tw.h3`text-lg sm:text-xl font-semibold mb-4 relative inline-block after:content-[''] after:block after:h-[3px] after:w-12 after:bg-gradient-to-r after:from-primary-color after:to-blue-400 after:mt-1 after:rounded-full`;
// const TermsGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4`;
// const TermCard = tw.div`flex items-center gap-3 p-3 sm:p-4 bg-white/70 backdrop-blur-md border border-gray-200 rounded-xl shadow-sm `;
// const IconWrapper = tw.div`flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-primary-color/10 text-primary-color flex-shrink-0`;
// const AmenitiesGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4`;
// // Booking Card Components
// const BookingCard = tw.div`sticky top-24 border rounded-2xl shadow-xl p-4 sm:p-6 bg-white`;
// const SharingOption = tw.div`cursor-pointer border rounded-xl p-3 sm:p-4 transition-allhover:shadow-md`;
// // Full Screen Modal Components
// const ModalOverlay = tw.div`fixed inset-0 bg-black/95 z-50 flex items-center justify-center`;
// const CloseButton = tw.button`absolute top-4 right-4 z-50 text-white hover:text-gray-300 transition-colors bg-black/50 rounded-full p-2`;
// const ModalContent = tw.div`w-full h-full flex flex-col items-center justify-center p-4`;
// const ImageContainer = tw.div`relative flex items-center justify-center w-full h-[50vh] sm:h-[60vh] md:h-[70vh]`;
// const FullScreenImage = tw.img`max-w-full max-h-full object-contain`;
// const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full p-2 sm:p-3 hover:bg-black/70 transition-all z-10`;
// const ImageCounter = tw.div`absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm`;
// const ThumbnailStrip = tw.div`flex gap-2 sm:gap-3 mt-4 sm:mt-6 overflow-x-auto pb-2 max-w-[90vw]`;
// const ThumbnailButton = tw.button`flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden border-2 transition-all`;

// export default PropertyShareLink;
























import React, { useState } from "react";
import tw from "tailwind-styled-components";
import {
  FaChevronLeft,
  FaChevronRight,
  FaPhone,
  FaEnvelope,
  FaCommentDots,
  FaBed,
  FaBath,
} from "react-icons/fa";
import { IoShareSocial } from "react-icons/io5";
import {
    FieldWrapper,
    InputGroup,
    Label,
} from "../../Components/Styles/InputStyles";
import moment from "moment";
import Images from "../../Images";
import { IoMdShare } from "react-icons/io";
import { FaKitchenSet } from "react-icons/fa6";
import ImagesModal from "../../Components/ImagesModal";
import { object } from "yup";

const propertyData = {
  id: 101,
  title: "Richardson Lofts",
  address: "71 Rossi St, San Francisco, CA 94107",
  price: 1180000,
  expectedReturn: "$4,500 - $5,450",
  beds: 7,
  baths: 2,
  kitchens: 2,
  sqftPrice: 367,
  yearBuilt: 1982,
  style: "Townhouse",
  lotSize: "9,609 sq.ft",
  status: "For Sale",
  timeOnPlatform: "47 days",

  quickFacts: [
    { label: "Property Type", value: "Apartment" },
    { label: "Beds", value: 3 },
    { label: "Baths", value: 2 },
    { label: "Price per sqft", value: "$367" },
    { label: "Year Built", value: 1982 },
    { label: "Style", value: "Townhouse" },
    { label: "Lot Size", value: "9,609 sq.ft" },
    { label: "Status", value: "For Sale" },
    { label: "Station", value: "Metro" },
  ],

  details: {
    overview:
      "Beautifully renovated urban design with historic character. Located in downtown Newark with modern fixtures and open layouts.",
    propertyType: "Apartment",
    builtYear: 1982,
    flooring: "Hardwood",
    parking: "2 Car Garage",
    heating: "Central Heating",
    cooling: "Central Air",
    HOA: "$250/month",
  },
  amenities: {
  interior: [
    "Master Bathroom",
    "Walk-in Closet",
    "Hardwood Flooring",
  ],
  exterior: [
    "Private Balcony",
    "Garden Area",
  ],
  utilities: [
    "Central Air Conditioning",
    "24/7 Water Supply",
    "24×7 Security",
    "Fire Fighting System",
    "Power Backup",
    "Lift",
    "Club House",
    "Gym",
    "Swimming Pool",
    "Library",
    "Children Play Area",
    "Gated Community",
    "Smoke Detector"

  ],
  // features: [
  //   "Bus Stop",
  //   "Railway Station",
  //   "Airport",
  //   "Hospital",
  //   "Temple",
  //   "Grocery Store",
  // ]
},

  agent: [
    {
      id: 1,
      name: "Watkin",
      phone: "+1 415 555 7890",
      email: "tommy.watkin@example.com",
      rebate: "$3,600 rebate available",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80",
    },
    {
      id: 2,
      name: "Tommy",
      phone: "+1 415 555 7890",
      email: "tommy.watkin@example.com",
      rebate: "$3,600 rebate available",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80",
    },
    {
      id: 3,
      name: "TommyWatkin",
      phone: "+1 415 555 7890",
      email: "tommy.watkin@example.com",
      rebate: "$3,600 rebate available",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80",
    },
  ],

  images : [
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1000",
  "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1000",
  "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1000",
  "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1000",
  "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1000",
  "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1000",
  "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000",
  "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1000",
  "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=1000",
  "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=1000",
  "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1000",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1000",

],


roomImages: {
  bedroom: {
    bedroom1: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1000",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000"
    ],
    bedroom2: [
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1000"
    ],
    bedroom3: [
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000"
    ],
     bedroom4: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1000",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000"
    ],
    bedroom5: [
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1000"
    ],
    bedroom6: [
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000"
    ],
     bedroom7: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1000",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=1000"
    ],
  },

  bathroom: {
    bathroom1: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1000"
    ],
    bathroom2: [
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=1000"
    ]
  },

  kitchen: {
    kitchen1: [
      "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?w=1000"
    ],
    kitchen2: [
      "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1000"
    ],
  }
}
};

const PropertyListing = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [viewDetail, setViewDetail] = useState(false);
  const [modalData, setModalData] = useState(null);

  const nextImage = () => {
    setCurrentImageIndex(
      (prev) => (prev + 1) % propertyData.images.length
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) =>
        (prev - 1 + propertyData.images.length) %
        propertyData.images.length
    );
  };

// const openRoomModal = (roomType) => {
//   setModalData({
//     title: roomType.toUpperCase(),
//     images: propertyData.roomImages[roomType],
//   });
//   setViewDetail(true);
// };


const openRoomModal = (roomType) => {

  const roomsObject = propertyData.roomImages[roomType];

  if(!roomsObject || Object.keys(roomsObject).length == 0){
    alert(`No ${roomType} images available`);
    return;
  }

  const rooms = Object.entries(roomsObject).map(([key, images], index) => ({
    name: `${roomType.toUpperCase()} ${index + 1}`,
    images
  }));

  setModalData({
    title: roomType.toUpperCase(),
    rooms
  });

  setViewDetail(true);
};
  const handleDateChange = (e) => { 
    const value = e.target.value;
    if (value) {
      setSelectedDate(moment(value).format("DD MMMM YYYY"));
    }
  };

  const Fact = ({ label, value }) => (
    <div>
      <p className="text-xs text-gray-600 font-medium mb-1">{label}</p>
      <p className="text-sm font-semibold text-gray-900">{value}</p>
    </div>
  );

const AmenityGroup = ({ title, items }) => (
  <div>
    <h4 className="font-semibold text-gray-900 mb-3">{title}</h4>
    <div className="grid grid-cols-2 gap-3">
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2 text-sm text-gray-700">
          <span className="text-green-600 font-bold">✓</span>
          {item}
        </div>
      ))}
    </div>
  </div>
);

  return (
    <PageWrapper>
      <Container>
        <GridLayout>
          <div className="col-span-2">
            <ImageWrapper>
              <img
                src={propertyData.images[currentImageIndex]}
                alt="Property main"
                className="w-full h-full object-cover"
              />

              <NavButton onClick={prevImage} className="left-4">
                <FaChevronLeft />
              </NavButton>

              <NavButton onClick={nextImage} className="right-4">
                <FaChevronRight />
              </NavButton>

              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-custom-black/60 text-white px-3 py-1 rounded text-sm">
                {currentImageIndex + 1}/{propertyData.images.length}
              </div>
            </ImageWrapper>

            {/* Thumbnails */}
            <div className="flex gap-2 overflow-x-auto pb-2">
              {propertyData.images.map((img, idx) => (
                <ThumbButton
                  key={idx}
                  onClick={() => setCurrentImageIndex(idx)}
                  className={
                    idx === currentImageIndex
                      ? "border-primary-color"
                      : "border-gray-300"
                  }
                >
                  <img
                    src={img}
                    alt={`Thumbnail ${idx}`}
                    className="w-full h-full object-cover"
                  />
                </ThumbButton>
              ))}
            </div>
          </div>

          {/* RIGHT - PROPERTY INFO */}
          <div className="col-span-1">
            <div className="flex items-center justify-between mb-1">
            <h1 className="text-2xl font-bold text-gray-900">
              {propertyData.title}
            </h1>

            <button className="p-2 rounded-full hover:bg-gray-100 transition">
              <IoMdShare className="text-xl text-gray-600 hover:text-primary-color" />
            </button>
          </div>
            <p className="text-gray-600 text-sm mb-2">
              {propertyData.address}
            </p>

            {/* Beds & Baths */}
            <div className="flex gap-6 mb-2">
                <div
                  className="flex items-center gap-2 cursor-pointer hover:text-primary-color"
                  onClick={() => openRoomModal("bedroom")}
                >
                  <FaBed />
                  <span>{propertyData.beds}</span>
                </div>

                <div
                  className="flex items-center gap-2 cursor-pointer hover:text-primary-color"
                  onClick={() => openRoomModal("bathroom")}
                >
                  <FaBath />
                  <span>{propertyData.baths}</span>
                </div>

                <div
                  className="flex items-center gap-2 cursor-pointer hover:text-primary-color"
                  onClick={() => openRoomModal("kitchen")}
                >
                  <FaKitchenSet />
                  <span>{propertyData.kitchens}</span>
                </div>
            </div>

            {/* Price */}
            <div className="bg-gray-100 rounded-lg p-2 mb-3">
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <p className="text-sm text-gray-600">Sale Price</p>
                  <p className="text-lg font-bold">{propertyData.price}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Return</p>
                  <p className="text-lg font-bold text-primary-color">
                    {propertyData.expectedReturn}
                  </p>
                </div>
              </div>
            </div>


            <div className="border-y py-3 mb-2">
              <h3 className="text-sm font-semibold mb-2">
                Connect with an agent
              </h3>
              <div className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory no-scrollbar">
                {propertyData.agent.map((agent)=>(
                  <div key={agent.id} className="min-w-[90%] p-2 rounded-lg border flex-shrink-0 snap-center">
                    <div  className="flex items-center gap-3 mb-3">
                    <img
                      src={agent.image}
                      alt={agent.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold">{agent.name}</p>
                      <p className="text-xs text-gray-500">
                        {agent.rebate}
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-2">
                    <button className="flex-1 flex items-center justify-center gap-2 py-2 border rounded-lg hover:bg-gray-50 text-sm">
                      <FaPhone /> Call
                    </button>

                    <button className="flex-1 flex items-center justify-center gap-2 py-2 border rounded-lg hover:bg-gray-50 text-sm">
                      <FaEnvelope /> Email
                    </button>

                    <button className="w-10 flex items-center justify-center border rounded-lg hover:bg-gray-50">
                      <FaCommentDots />
                    </button>
                  </div>
                </div>
                ))}
              </div>
            </div>

            
            <div className="mb-2">
              <h3 className="text-sm font-semibold mb-3">
                Tour this inventory
              </h3>

              <InputGroup className="w-full">
                {/* <Label htmlFor="tourDate">Select Tour Date</Label> */}

                <FieldWrapper className="h-12 cursor-pointer">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <input
                    type="date"
                    id="tourDate"
                    min={moment().format("YYYY-MM-DD")}
                    onChange={handleDateChange}
                    className="w-full bg-transparent outline-none cursor-pointer"
                  />
                </FieldWrapper>
              </InputGroup>

              {selectedDate && (
                <div className="mt-3 text-sm text-primary-color font-semibold">
                  Selected Date: {selectedDate}
                </div>
              )}

              <PrimaryButton
                className="mt-4"
                disabled={!selectedDate}
              >
                Schedule a Tour
              </PrimaryButton>
            </div>
          </div>
        </GridLayout>
        <div className="mb-8">
          <h2 className="text-xl font-bold mb-4">Inventory Quick Facts</h2>

          <div className="bg-white rounded-lg p-6 border">
            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
              {propertyData.quickFacts.map((fact, index) => (
                <Fact
                  key={index}
                  label={fact.label}
                  value={fact.value}
                />
              ))}
            </div>
          </div>
        </div>

        <Section
          title="Inventory Details"
          content="Beautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartments include thoughtfully-designed layouts and modern fixtures.Beautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartmenBeautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartmenBeautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartmen Beautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartmenBeautifully renovated urban design and comforts to historic character. Richardson Lofts is at the heart of downtown Newark. All apartmen"
        />

        <div className="mb-8">
          <h2 className="text-xl font-bold mb-4">Custom Features</h2>

          <div className="bg-white rounded-lg p-6 border space-y-6">

            <AmenityGroup title="Interior" items={propertyData.amenities.interior} />
            <AmenityGroup title="Exterior" items={propertyData.amenities.exterior} />
            <AmenityGroup title="Utilities" items={propertyData.amenities.utilities} />
            {/* <AmenityGroup title="Extra Features" items={propertyData.amenities.features}/> */}
          </div>
        </div>
      </Container>
       {viewDetail && (
        <ImagesModal
          setViewDetail={setViewDetail}
          selectedData={modalData}
        />
      )} 
    </PageWrapper>
  );
};


const Section = ({ title, content }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold mb-4">{title}</h2>

      <div className="bg-white rounded-lg p-6 border">
        <p
          className={`text-gray-700 text-sm mb-4 transition-all duration-300 ${
            expanded ? "" : "line-clamp-3"
          }`}
        >
          {content}
        </p>

        <button
          onClick={() => setExpanded(!expanded)}
          className="text-primary-color text-sm font-semibold hover:underline transition"
        >
          {expanded ? "View less" : "View more"}
        </button>
      </div>
    </div>
  );
};

export default PropertyListing;


const PageWrapper = tw.div`min-h-screen bg-gray-50`;
const Container = tw.div`max-w-7xl mx-auto px-4 py-8`;
const GridLayout = tw.div`grid grid-cols-3 gap-8 mb-8`;
const ImageWrapper = tw.div`relative bg-gray-200 rounded-lg overflow-hidden mb-4 h-96`;
const NavButton = tw.button`absolute top-1/2 -translate-y-1/2 bg-white rounded-full p-2 hover:bg-gray-100 shadow-lg z-10`;
const ThumbButton = tw.button`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2`;
const PrimaryButton = tw.button`w-full bg-primary-color text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition`;